import {gql} from "@apollo/client";

export const GET_ASSIGNMENT_ORGANIZATIONS = gql`
    query AssignmentOrganizations($profileId: Int!) {
        organizations(profileId: $profileId, page: 1, pageSize: 1000) {
            objects {
                id
                slug
                name
                activeSubscription {
                    plan {
                        id
                        features { key }
                    }
                }
                divisions {
                    id
                    name
                    seasons { id name slug }
                    activeSeason { id name slug }
                    sport { key name }
                }
                fields { id name }
            }
        }
    }
`;

export const GET_ORGANIZATION_ASSIGNMENT_EVENTS = gql`
    query OrganizationRefereeAssignmentEvents(
        $organizationId: Int!
        $assignmentStatus: String
        $divisionId: Int
        $seasonId: Int
        $stageId: Int
        $dateFrom: Date
        $dateTo: Date
        $fieldId: Int
        $managerId: Int
        $refereeId: Int
        $page: Int
        $pageSize: Int
    ) {
        organizationRefereeAssignmentEvents(
            organizationId: $organizationId
            assignmentStatus: $assignmentStatus
            divisionId: $divisionId
            seasonId: $seasonId
            stageId: $stageId
            dateFrom: $dateFrom
            dateTo: $dateTo
            fieldId: $fieldId
            managerId: $managerId
            refereeId: $refereeId
            page: $page
            pageSize: $pageSize
        ) {
            objects {
                id
                title
                description
                eventType
                status
                date
                timezone
                responsibles
                managers
                address
                city
                state
                country
                latitude
                longitude
                stage {
                    id
                    name
                    stageReferees { id fullName rating }
                }
                season {
                    id
                    name
                    division { id name sport { key name } }
                }
                field { id name }
                game {
                    id
                    homeTeam { id name logoUrl }
                    visitorTeam { id name logoUrl }
                    homeTeamAlias
                    visitorTeamAlias
                    group { id name }
                    matchDay
                }
            }
            page
            pages
            hasNext
            hasPrev
            totalCount
        }
    }
`;

export const GET_ASSIGNMENT_EVENT_STATUSES = gql`
    query AssignmentEventStatuses($eventIds: [ID!]!) {
        eventRefereeAssignmentsForEvents(eventIds: $eventIds) {
            id
            event { id }
            referee { id fullName email }
            status
            createdAt
            invitedAt
            respondedAt
            completedAt
            assignedBy { firstName lastName email }
        }
    }
`;

export const BULK_ASSIGN_COORDINATORS_OR_FIELD = gql`
    mutation BulkAssignOperations(
        $eventIds: [ID!]!
        $fieldId: Int
        $managerIds: [Int]
    ) {
        bulkEditEvents(eventIds: $eventIds, fieldId: $fieldId, managerIds: $managerIds) {
            success
            message
            updatedEvents { id }
        }
    }
`;
